/**
 * The string used for the keys in the the encryption key map.
 * `@bob:examle.org:DEVICEID(UUIDRANDOM_MEMBERID_RANDOMUUID)`
 */
export function getEncryptionKeyMapKey(membership) {
  return "".concat(membership.userId, ":").concat(membership.deviceId, "(").concat(membership.memberId, ")");
}

/**
 * This interface is for testing and for making it possible to interchange the encryption manager.
 * @internal
 */
//# sourceMappingURL=EncryptionManager.js.map